var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-element-loading',{attrs:{"active":_vm.loading}}),_c('b-img',{attrs:{"src":_vm.source,"alt":_vm.alt,"thumbnail":_vm.thumbnail,"fluid-grow":""},on:{"error":_vm.imageLoadError,"load":_vm.imageLoad}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }